<div class="blurb-text-cont">
  <!-- Edit mode -->
  <div class="row row justify-content-center hover" *ngIf="isEditMode">
    <!-- Text Results -->
    <div class="col-md-9 col-sm-9 col-lg-9" style="padding: 0;">
      <div>
        <div class="blurb-text-container">
          <div>
            <!-- <angular-editor id="textAreaData" [(ngModel)]="textAreaData" [config]="dropAreaConfig">
                        </angular-editor> -->
            <quill-editor name="textAreaData" [(ngModel)]="textAreaData" [modules]="quillModules"></quill-editor>
          </div>
        </div>
      </div>
    </div>

    <!-- Search / List / Add-Edit -->
    <div class="Col-md-3 col-sm-3 col-lg-3 paddingRightZero">
      <div class="blurb-items">
        <div class="blurb-item-container">
          <!-- Search -->
          <div class="search-div">
            <input type="text" name="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
            <!-- Add new blurb -->
            <button class="btn btn-rbv m-l-10" type="button" (click)="openModalToAddBlurb()"
              *ngIf="type === 'PREPARED_STATEMENT_GENERAL'">
              <i class="fa fa-plus"></i>
              Add
            </button>
          </div>

          <!-- Sort (ASC/DESC) -->
          <div class="m-b-10">
            <button class="btn btn-rbv w-100" type="button" (click)="sortBlurbList()">
              <i class="fa fa-sort-amount-{{sortType === 'DESC' ? 'asc' : 'desc'}}"></i>
              Sort ({{sortType === 'DESC' ? 'ASC' : 'DESC'}})
            </button>
          </div>

          <div class="blurb-list-item-div">
            <!-- List of IBIS -->
            <div *ngIf="PS_IBIS_List?.length > 0">
              <div class="blurb-list ibis-list">
                <div class="ibis-item-content" *ngFor="let item of PS_IBIS_List | filter: ['HEADER'] : searchText; let i = index;"
                  [ngClass]="{'blue': item.FAVORITE}">
                  <div (click)="addTextToTextarea(item)">
                    {{item.HEADER}}
                  </div>
                </div>
              </div>
            </div>

            <!-- List of General Prepared Statements -->
            <div>
              <div class="blurb-list" *ngIf="PS_GENERAL_LIST?.length > 0">
                <div *ngFor="let item of PS_GENERAL_LIST | filter: ['HEADER'] : searchText; let i = index;">
                  <div (click)="addTextToTextarea(item)" class="blurb-item-content">
                    <i class="fa fa-exclamation-triangle invalidBlurb"
                      *ngIf="type === 'PREPARED_STATEMENT_GENERAL' && item.MARK_AS_INVALID"></i>
                    {{item.HEADER}}
                    <i class="fa fa-pencil editBlurb" *ngIf="type === 'PREPARED_STATEMENT_GENERAL' "
                      (click)="editBlurb(item);commonService.preventClick($event);"></i>
                  </div>
                </div>
              </div>
              <div *ngIf="PS_GENERAL_LIST.length == 0">No items available</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- View mode -->
  <div *ngIf="!isEditMode">
    <div *ngIf="!textAreaData" class="default-container">
      <div class="default-data">
        <div style="font-weight: 600; font-size: 16px;">
          Prepared Statements
        </div>
        <div style="margin: 10px 0;">To add items to this section enter Edit mode by clicking button below
        </div>
        <div>
          <button type="button" class="btn btn-rbv" (click)="changeToEditMode()"><i
              class="fa fa-pencil editButtonIcon"></i>Edit mode</button>
        </div>
      </div>
    </div>
    <div *ngIf="textAreaData" class="actual-data" [innerHTML]="textAreaData | safeHtml"></div>
  </div>
</div>

<!-- Modal to add new blurb -->
<ng-template #blurbTextAddNewBlurb>
  <!-- Header -->
  <div class="modal-header">
    <h4 class="modal-title pull-left">Add blurb</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeNewBlurbModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Body -->
  <div>
    <app-blurb-new [isFromModal]="true" (modalClose)="updateBlurbsList($event)"></app-blurb-new>
  </div>
</ng-template>
